import * as StyleFunctions from '../utilities/StyleFunctions';
import TableGrid from '../StockItems/TableGrid';

function App(props) {

  var anItem = props.anItem;
  var getOrig = props.getOrig;
  var stylePath = props.stylePath;
  var screenSize = props.screenSize;
  var currentScreenStyle = props.currentScreenStyle;
  var getStylePath = props.getStylePath;
  var organicChanges = props.organicChanges;
  var toggler = props.toggler;


  var whatDrop2 = anItem.i;
  var orig2 = getOrig(whatDrop2);

    var opt = [];

    if (whatDrop2 === 'vDimensions'){
      opt = [{t:'16 x 9', i:'embed-responsive-16by9'}, {t:'4 x 3', i:'embed-responsive-4by3'}, {t:'21 x 9', i:'embed-responsive-21by9'}, {t:'1 x 1', i:'embed-responsive-1by1'}];
    }else if (whatDrop2 === 'justifyContent'){
      opt = [{t:'Left',i:'start', ic:'akar-icons:text-align-left'}, {t:'Center', i:'center', ic:'akar-icons:text-align-center'}, {t:'Right', i:'end', ic:'akar-icons:text-align-right'}];
    }else if (whatDrop2 === 'textAlignment'){
      opt = [{t:'Left',i:'text-left', ic:'akar-icons:text-align-left'}, {t:'Center', i:'text-center', ic:'akar-icons:text-align-center'}, {t:'Right', i:'text-right', ic:'akar-icons:text-align-right'}, {t:'Justify', i:'text-justify', ic:'bi:justify'}];
    }else if (whatDrop2 === 'alignItems'){
      opt = [{t:'Top', i:false, ic:'akar-icons:align-to-top'}, {t:'Middle', i:'center', ic:'akar-icons:align-to-middle'}, {t:'Bottom', i:'end', ic:'akar-icons:align-to-bottom'}];
    }else if (whatDrop2 === 'vTop'){
      opt = [{t:'Top', i:false, ic:'akar-icons:align-to-top'}, {t:'Middle', i:'my-auto', ic:'akar-icons:align-to-middle'}];
    }else if (whatDrop2 === 'mvtIcon'){
      opt = [{t:'Circled', i:'bxs:chevron-left-circle', ic:'bxs:chevron-left-circle'}, {t:'Single', i:'bi:chevron-left', ic:'bi:chevron-left'}, {t:'Double', i:'fluent:chevron-double-left-16-filled', ic:'fluent:chevron-double-left-16-filled'}];
    }else if (whatDrop2 === 'indvPadding'){
      opt = [{t:'All', i:0, ic:'tabler:arrows-join-2', aC:[{t:'w', w:stylePath.concat(['padding']), n:{t:'int', v:1}}]}, {t:'Each',i:1, ic:'raphael:split'}, {t:'Default',i:false,ic:'ic:round-check-box-outline-blank', aC:[{t:'r', w:stylePath, i:'padding'}, {t:'r', w:stylePath, i:'paddingLeft'}, {t:'r', w:stylePath, i:'paddingTop'}, {t:'r', w:stylePath, i:'paddingRight'}, {t:'r', w:stylePath, i:'paddingBottom'}]}];
    }else if (whatDrop2 === 'buttonColorSet'){
      opt = [{t:'Standard', i:false, ic:'gis:polyline-pt'}, {t:'Custom',i:'custom', ic:'gis:modify-line'}];
    }else if (whatDrop2 === 'tooltipLocation'){
      opt = [{t:'Top', i:false, ic:'mdi:tooltip-plus-outline'}, {t:'Left',i:'left', ic:'mdi:tooltip-plus-outline', rotate:'270deg'}, {t:'Right',i:'right', ic:'mdi:tooltip-plus-outline', rotate:'90deg'}, {t:'Bottom', vFlip:true, i:'bottom', ic:'mdi:tooltip-plus-outline'}];
    }else if (whatDrop2 === 'tooltipShade'){
      opt = [{t:'Dark', i:false, ic:'mdi:tooltip-plus', vFlip:true}, {t:'Light',i:'tooltipWhite', ic:'mdi:tooltip-plus-outline', vFlip:true}];
    }else if (whatDrop2 === 'navbarTextShade'){
      opt = [{t:'Dark', i:'navbar-light', ic:'material-symbols:light-mode-sharp'}, {t:'Light',i:'navbar-dark', ic:'material-symbols:light-mode-outline-sharp'}];
    }else if (whatDrop2 === 'hoverEffect'){
      opt = [{t:'Bold',i:'dropdownItemTextBoldHover', ic:'bi:type-bold'}, {t:'Underline',i:'dropdownItemTextUnderHover', ic:'ant-design:underline-outlined'}, {t:'Lighter',i:'dropdownItemDivHoverLighter', ic:'material-symbols:light-mode-sharp'}, {t:'Darker',i:'dropdownItemDivHoverDarker', ic:'material-symbols:light-mode-outline-sharp'}, {t:'None', i:false, ic:'ic:round-check-box-outline-blank'}];

    }else if (whatDrop2 === 'radioTick'){
      opt = [{t:'Circle',i:false, ic:'eva:radio-button-on-fill'}, {t:'Tick',i:'cuesTick', ic:'subway:tick'}];
    }else if (whatDrop2 === 'radioShape'){
      opt = [{t:'Circle',i:false, ic:'material-symbols:circle-outline'}, {t:'Square',i:'square', ic:'material-symbols:square-outline'}];

    }else if (whatDrop2 === 'shadeWhenHover'){
      opt = [{t:'Dark', i:false, ic:'fluent:cursor-hover-off-48-regular'}, {t:'Light',i:'Light', ic:'fluent:cursor-hover-16-filled'}];
    }else if (whatDrop2 === 'tableHover'){
      opt = [{t:'No', i:false, ic:'fluent:cursor-hover-off-48-regular'}, {t:'Yes',i:'table-hover', ic:'fluent:cursor-hover-16-filled'}];
    }else if (whatDrop2 === 'tableBordered'){
      opt = [{t:'No', i:false, ic:'cil:border-clear'}, {t:'Yes',i:'table-bordered', ic:'bi:border-all'}];
    }else if (whatDrop2 === 'tableStriped'){
      opt = [{t:'No', i:false, ic:'fluent:table-freeze-row-24-regular'}, {t:'Yes',i:'table-striped', ic:'fluent:table-freeze-row-28-filled'}];
    }else if (whatDrop2 === 'tableDark'){
      opt = [{t:'No', i:false, ic:'fluent:table-simple-28-regular'}, {t:'Yes',i:'table-dark', ic:'fluent:table-simple-48-filled'}];
    }else if (whatDrop2 === 'selectStyle'){
      opt = [{t:'Classic', i:false, ic:'octicon:multi-select-16'}, {t:'Square',i:'square', ic:'octicon:single-select-24'}];
    }else if (whatDrop2 === 'noGutter'){
      opt = [{t:'None', i:'no-gutters', ic:'fluent:align-space-around-horizontal-20-regular'}, {t:'Spacing',i:false, ic:'fluent:align-space-between-horizontal-20-regular'}];
    }else if (whatDrop2 === 'detailsStyle'){
      opt = [
        {t:'One', ic:'tabler:circle-1', i:'One', aC:[{t:'w', w:stylePath.concat(['color']), n:{t:'raw', v:'rgb(255, 255, 255)'}}, {t:'w', w:stylePath.concat(['backgroundColor']), n:{t:'raw', v:'rgb(167, 108, 86)'}}]}, 
        {t:'Two', ic:'tabler:circle-2', i:'Two', aC:[{t:'w', w:stylePath.concat(['color']), n:{t:'raw', v:'rgb(0, 0, 0)'}}, {t:'w', w:stylePath.concat(['backgroundColor']), n:{t:'raw', v:'rgb(167, 108, 86)'}}]}, 
        {t:'Three', ic:'tabler:circle-3', i:'Three', aC:[{t:'w', w:stylePath.concat(['color']), n:{t:'raw', v:'rgb(167, 108, 86)'}}, {t:'r', w:stylePath, i:'backgroundColor'}]}, 
        {t:'Four', ic:'tabler:circle-4', i:'Four', aC:[{t:'w', w:stylePath.concat(['color']), n:{t:'raw', v:'rgb(167, 108, 86)'}}, {t:'r', w:stylePath, i:'backgroundColor'}]}];
    }else if (whatDrop2 === 'galleryHover'){
      opt = [
        {t:'None', ic:'ic:round-check-box-outline-blank', i:false}, 
        {t:'One', ic:'tabler:circle-1', i:'galleryHover1'}, 
        {t:'Two', ic:'tabler:circle-2', i:'galleryHover2'}, 
        {t:'Three', ic:'tabler:circle-3', i:'galleryHover3'}, 
        {t:'Four', ic:'tabler:circle-4', i:'galleryHover4'}];
    }else if (whatDrop2 === 'scrollIn'){
      opt = [
        {t:'None', ic:'ic:round-check-box-outline-blank', i:false}, 
        {t:'Left', ic:'icon-park-outline:right-two', i:'slideLeft'}, 
        {t:'Right', ic:'icon-park-outline:left-two', i:'slideRight'}, 
        {t:'Bottom', ic:'icon-park-outline:up-two', i:'fadeInBottom'}, 
        {t:'Appear', ic:'svg-spinners:bars-fade', i:'fadeIn'}];

    }else if (whatDrop2 === 'timerType'){
      opt = [
        {t:'Wide', ic:'tabler:viewport-wide', i:false}, 
        {t:'Short', ic:'tabler:viewport-narrow', i:'narrowTimer'}];

    }

    var doClick = function(aCell){
        toggler(aCell.i, whatDrop2, aCell.aC)();
    }

    if (screenSize === 0){
    }else if (whatDrop2 === 'justifyContent'){

      var customPiece;
      var referenceX = StyleFunctions.sizePointer(screenSize);
      var amt = StyleFunctions.minScreenSize(screenSize);
      var thisSet = currentScreenStyle[whatDrop2];
      if (thisSet){
        var stylePath2 = getStylePath(whatDrop2);
        if (thisSet[referenceX]){
          doClick = function(aCell){
              organicChanges([{t:'w',w:stylePath2.concat([whatDrop2, referenceX]),n:aCell.i}])
          }

          function removeCustom(e){
            organicChanges([{t:'r',w:stylePath2.concat([whatDrop2]),i:referenceX}])
          }
          var origValueText = '';
          for (var i29 = 0; i29 < opt.length; i29++){
            if (opt[i29].i === orig2){
              origValueText = opt[i29].t;
              break;
            }
          }

          customPiece = <center>Baseline value is {origValueText}, which can be modified by selecting the portrait phone icon on the top bar. This modification is for screen widths greater than {amt}px. <u onClick={removeCustom} style={{cursor:'pointer'}}>Remove</u> custom value.</center>
          orig2 = thisSet[referenceX];

//
        }else{
          function addCustom1(e){
            var origDistance = {t:'raw',v:orig2};
            origDistance[referenceX] = orig2;
            organicChanges([{t:'w',w:stylePath2.concat([whatDrop2]),n:origDistance}]);
          } 
          customPiece = <center><u style={{cursor:'pointer'}} onClick={addCustom1}>Add</u> a custom value for widths greater than {amt}px</center>

        }
      }

    }


    var r = <TableGrid options={opt} currentAnswer={orig2} onClick={doClick} />
    return (<td>{anItem.n}{r}{customPiece}</td>)

}





//
export default App;
